import { useState, useEffect, useCallback, useRef } from "react";
import { useAuth } from "@/contexts/AuthContext";

export function useKitchenAnalytics() {
  const { authAxios } = useAuth();
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [kitchen, setKitchen] = useState(null);
  const [heatmap, setHeatmap] = useState(null);
  const [bottlenecks, setBottlenecks] = useState(null);
  const [efficiency, setEfficiency] = useState(null);
  const [benchmark, setBenchmark] = useState(null);
  const [loading, setLoading] = useState(true);
  const [analyzing, setAnalyzing] = useState(false);
  const [days, setDays] = useState("7");

  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [k, h, b, e, bm] = await Promise.all([
        authAxios.get(`/analytics/v2/operations/kitchen?days=${days}`).catch(() => ({ data: null })),
        authAxios.get(`/analytics/v2/operations/heatmap?days=30`).catch(() => ({ data: null })),
        authAxios.get(`/analytics/v2/operations/bottlenecks`).catch(() => ({ data: null })),
        authAxios.get(`/analytics/v2/operations/efficiency?days=${days}`).catch(() => ({ data: null })),
        authAxios.get(`/analytics/v2/operations/benchmark?days=${days}`).catch(() => ({ data: null })),
      ]);
      setKitchen(k.data);
      setHeatmap(h.data);
      setBottlenecks(b.data);
      setEfficiency(e.data);
      setBenchmark(bm.data);
    } catch { /* */ }
    setLoading(false);
  }, [authAxios, days]);

  useEffect(() => { fetchAll(); }, [fetchAll]);

  const handleAnalyze = async () => {
    setAnalyzing(true);
    await new Promise(r => setTimeout(r, 2000));
    setAnalyzing(false);
  };

  return {
    kitchen, heatmap, bottlenecks, efficiency, benchmark,
    loading, analyzing, days, setDays,
    fetchAll, handleAnalyze,
  };
}
